import * as React from "react"
import {CardSeeker} from "@ui-seeker/core";

import {PercentageChartNew} from "@components";
import {GROUPED_BY, BANNERS_ROUTES} from "@constants";
import {useBannerPercentageHighLevel, useBannersPercentageLink} from "../@hooks";
import BannersPercentageHighLevelSkeleton from "./Skeleton";
import BannersPercentageHighLevelLegend from "./Legend";
import BannerPercentageToolbar from "../Toolbar";


export default function BannersPercentageHighLevel() {
    const { isLoading, data, shareKey, handleChangeShareKey, isClickedRemaining, shareTitle, handleDownload } = useBannerPercentageHighLevel()
    const { buildLink } = useBannersPercentageLink(BANNERS_ROUTES.TOP_BANNERS_PATH)

    if (isLoading) return <BannersPercentageHighLevelSkeleton isLoading={isLoading} />
    if (!data.length) return <></>

    return <CardSeeker
        title={`High level analysis by ${shareTitle}`}
        actions={<BannerPercentageToolbar
            groupedBySelected={shareKey}
            onChangeGroupedBy={handleChangeShareKey}
            excludeOptions={[GROUPED_BY.COUNTRY, GROUPED_BY.RETAILER]}
            onDownload={handleDownload}
        />}
        footer={<BannersPercentageHighLevelLegend data={data} />}
    >
        <PercentageChartNew
            data={data.map(item => ({
                ...item,
                width: item.share,
                prevWidth: item.prevShare,
                diff: item.diff,
                link: item.remainingData
                    ? item.remainingData.length && isClickedRemaining ? buildLink(item) : null
                    : buildLink(item),
            }))}
            label="High Level"
        />
    </CardSeeker>
}